export default __webpack_public_path__ + "static/media/banner5.6f0b4c6a.jpg";